// Subset of ReportPurchaseColumnName from ReportingService

export enum PurchaseReportTableGroupingColumnId {
  PurchaseOrderId = 'purchaseOrderId',
  OrderId = 'orderId',
  InsertBy = 'insertBy',
  PurchaseOrderDate = 'purchaseOrderDate',
  BuyerUserId = 'buyerUserId',
  PurchaseOrderVendorName = 'purchaseOrderVendorName',
  EncryptedEmailAddress = 'encryptedEmailAddress',
  PurchaseCancellationDate = 'purchaseCancellationDate',
  PurchasePaymentStatusName = 'purchasePaymentStatusName',
  PurchasePaymentMethodTypeName = 'purchasePaymentMethodTypeName',
  PaymentMethodFullInfo = 'paymentMethodFullInfo',
  InternalNotes = 'internalNotes',
  Office = 'office',
}

export enum PurchaseReportTableValueColumnId {
  UnitCost = 'unitCost',
  TotalCost = 'totalCost',
  OutstandingBalance = 'outstandingBalance',
  TotalPaymentAmount = 'totalPaymentAmount',
}

export const PURCHASE_REPORT_TABLE_FORMULA_COLUMNS: PurchaseReportTableValueColumnId[] =
  Object.values(PurchaseReportTableValueColumnId);
